import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterFeaturesDropdownMenuLogic} from "./FilterFeaturesDropdownMenu.logic";
import {DropdownFilterMenu} from "../../filters/dropdown-filter-menu/DropdownFilterMenu";
import {FilterFeatures} from "../filter-features/FilterFeatures";

export const FilterFeaturesDropdownMenu: VoidFunctionComponent = () => {
  const {label, onClickMenuToggleHandler, isActive, isAvailable, dropdownFilterMenuRef} = useFilterFeaturesDropdownMenuLogic();
  if (!isAvailable) {
    return null;
  }
  return <DropdownFilterMenu
    ref={dropdownFilterMenuRef}
    {...{label, onClickMenuToggleHandler, isActive}}
    component={FilterFeatures}
  />;
}
